import React from 'react';
import styles from './HomeScreen.module.css';

const HomeScreen = () => {
  return (
    <div className={styles['app-container']}>
      <header>
        <div className={styles.container}>
          <nav>
            <a href="/" className={styles.logo}>
              <div className={styles['logo-icon']}>N</div>
              No Notes
            </a>
            <a href="#join-waitlist" className={styles['nav-btn']}>Join Waitlist</a>
          </nav>
        </div>
      </header>
      
      <section className={styles.hero}>
        <div className={styles.container}>
          <h1>Physical Therapy Documentation in Seconds, Not Hours</h1>
          <p>No Notes turns brief session notes into complete documentation instantly. Less paperwork, more patient care.</p>
          
          <form className={styles['hero-email-form']}>
            <input 
              type="email" 
              placeholder="Enter your email address" 
              className={styles['hero-email-input']} 
              required
            />
            <button type="submit" className={styles['hero-submit-btn']}>Get Early Access</button>
          </form>
          <div className={styles['hipaa-badge']}>
            <div className={styles['hipaa-badge-icon']}>✓</div>
            <span className={styles['hipaa-badge-text']}>HIPAA Compliant & Secure</span>
          </div>
          <p className={styles['hero-privacy']}>Your data is always secure with us.</p>
        </div>
      </section>
      
      <section className={styles.container}>
        <div className={styles.features}>
          <div className={styles['feature-card']}>
            <div className={styles['feature-icon']}>
              <span>⚡</span>
            </div>
            <h3>Lightning Fast</h3>
            <p>Full notes generated in seconds from minimal input.</p>
          </div>
          
          <div className={styles['feature-card']}>
            <div className={styles['feature-icon']}>
              <span>📝</span>
            </div>
            <h3>Comprehensive</h3>
            <p>Daily notes, progress reports, evaluations and more with all required elements.</p>
          </div>
          
          <div className={styles['feature-card']}>
            <div className={styles['feature-icon']}>
              <span>🔒</span>
            </div>
            <h3>Compliant</h3>
            <p>HIPAA certified. Meets all industry standards. Audit-proof documentation every time.</p>
          </div>
        </div>
      </section>
      
      <section className={styles.container}>
        <div className={styles.demo}>
          <div className={styles['demo-content']}>
            <h2>How It Works</h2>
            
            <div className={styles['demo-step']}>
              <div className={styles['step-number']}>1</div>
              <p>Enter brief session details</p>
            </div>
            
            <div className={styles['demo-step']}>
              <div className={styles['step-number']}>2</div>
              <p>AI generates complete documentation</p>
            </div>
            
            <div className={styles['demo-step']}>
              <div className={styles['step-number']}>3</div>
              <p>Review, edit, and approve with a single click</p>
            </div>
          </div>
          
          <div className={styles['demo-illustration']}>
            <div className={styles['demo-ui-container']}>
              <div className={styles['demo-ui-bar']}></div>
              <div className={styles['demo-ui-content']}>Input Session Details</div>
              <div className={styles['demo-ui-actions']}>
                <div className={styles['demo-ui-button']}>Generate</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className={styles.container} id="join-waitlist">
        <div className={styles['email-collection']}>
          <h2>Join Our Early Access Program</h2>
          <p>Be among the first to reclaim your time and transform your practice.</p>
          
          <form className={styles['email-form']}>
            <input 
              type="email" 
              placeholder="Your work email address" 
              className={styles['email-input']} 
              required
            />
            <button type="submit" className={styles['submit-btn']}>Request Early Access</button>
          </form>
          
          <div className={styles['hipaa-badge']}>
            <div className={styles['hipaa-badge-icon']}>🔒</div>
            <span className={styles['hipaa-badge-text']}>HIPAA Compliant & Secure</span>
          </div>
        </div>
      </section>
      
      <section className={styles.container}>
        <div className={styles.testimonials}>
        <h2>What Therapists Say</h2>
          
          <div className={styles['testimonial-card']}>
            <p className={styles['testimonial-content']}>
            "Documentation that took 30 minutes now takes seconds. No Notes lets me spend that time where it matters—with my patients."
            </p>
            <div className={styles['testimonial-author']}>
              <div className={styles['author-avatar']}>DR</div>
              <div className={styles['author-info']}>
              <h4>Kelly J.</h4>
              <p>Pediatric PT</p>
              </div>
            </div>
          </div>
          
          <div className={styles['testimonial-card']}>
            <p className={styles['testimonial-content']}>
            "I used to dread documentation. Now I input session highlights and get perfect notes in seconds. Game-changer for my practice."
            </p>
            <div className={styles['testimonial-author']}>
              <div className={styles['author-avatar']}>JT</div>
              <div className={styles['author-info']}>
              <h4>Michael L.</h4>
              <p>Physical Therapist</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <footer>
        <div className={styles.container}>
        <p>© 2025 No Notes</p>
        </div>
      </footer>
    </div>
  );
};

export default HomeScreen;